/** @format */

import React, { useCallback, useEffect, useState } from 'react';
import compose from 'recompose/compose';
import withStyles from '@material-ui/core/styles/withStyles';
import adescomStyle from '../../../assets/jss/adescom/adescomStyle';
import GridContainer from '../../../components/Grid/GridContainer';
import GridItem from '../../../components/Grid/GridItem';
import { FormGeneralHelper } from '../../../helpers/FormGeneral';
import InputFormRest from '../../../components/Form/InputFormRest';
import { connect, useDispatch } from 'react-redux';
import CardHeader from '../../../components/Heading/CardHeaderExt';
import PieChart from '@material-ui/icons/PieChart';
import CardBody from '../../../components/Card/CardBody';
import Card from '../../../components/Card/Card';
import { history } from '../../../core/history';
import { NotificationHelper } from '../../../helpers/NotificationHelper';
import { ItemLoaders } from '../../../core/loaders/ItemLoaders';
import { makeStyles } from '@material-ui/core';
import { useParams } from 'react-router-dom';
import { fractionsConstants } from '../../../modules/fractions/actions';
import { roles, UserRoleHelper } from '../../../helpers/UserRoleHelper';
import CustomSmallTextButton from '../../../components/Buttons/CustomSmallTextButton';
import oplAppStyle from '../../../assets/themes/OPL/jss/App/OplAppStyle';

interface FractionEditProps {
    classes: any;
    items: any;
    dispatch: any;
    selectedClients: any;
    callback: any;
    match: any;
}

interface FractionEditState {
    entity: any;
    entityStatus: any;
    item: any;
    uri: string;
    deleteConfirm: boolean;
}

interface FractionEditInterface {
    mainname: string | null;
}

const FractionEdit = (props: FractionEditProps): React.ReactElement => {
    const dispatch = useDispatch();

    const { id } = useParams();
    const [entity, setEntity] = useState<FractionEditInterface>({ mainname: null });
    const [entityStatus, setEntityStatus] = useState<{ mainname: string | null; textid: string | null }>({ mainname: null, textid: null });

    const reload = useCallback(
        (saveEntity?: boolean): void => {
            const itemLoaders = new ItemLoaders(dispatch);
            itemLoaders.getWithCallback(
                FormGeneralHelper.getByUri(`/${id}`),
                fractionsConstants.ITEM,
                (data: any) => {
                    setEntity(data);
                },
                {
                    propagateDataToCallback: true,
                    dispatchAfterCallback: true,
                }
            );
        },
        [dispatch, id]
    );

    const changeInput = (e: any, stateName: string, type: string, require: boolean, maxValue: number, minValue: number): void => {
        setEntity({ ...entity, [stateName]: e.target.value });
    };

    const handleSubmit = (): void => {
        const itemLoader = new ItemLoaders(dispatch);
        itemLoader.putWithCallback(
            FormGeneralHelper.getByUri(`/${id}`),
            fractionsConstants.EDIT,
            entity,
            {
                onSuccess: (data: any) => {
                    NotificationHelper.notifySuccess('fractions:notify.modified_success', dispatch);
                },
                onError: () => {
                    NotificationHelper.notifyError('fractions:notify.added_error', dispatch);
                },
            },
            {
                propagateDataToCallback: false,
                dispatchAfterCallback: true,
            }
        );
    };

    const returnFractionList = (): void => {
        history.push(FormGeneralHelper.getRouteUrl('/fraction-list'));
    };

    useEffect(() => {
        reload();
    }, [reload]);

    return (
        <React.Fragment>
            <GridContainer>
                <GridItem xs={12}>
                    <Card>
                        <CardHeader icon={<PieChart />} trans="fractions:f.fraction" />
                        <CardBody>
                            <GridContainer>
                                <GridItem xs={12} md={12} lg={12}>
                                    <InputFormRest
                                        classes={props.classes}
                                        callback={changeInput}
                                        stateName="mainname"
                                        stateObjectState={entityStatus.mainname}
                                        typeCallback={FormGeneralHelper.TYPE_TEXT}
                                        typeField={FormGeneralHelper.TYPE_TEXT}
                                        displayFieldName="fractions:f.fraction_name"
                                        required={false}
                                        vMax={255}
                                        vMin={0}
                                        value={entity.mainname}
                                    />
                                </GridItem>
                                <GridItem xs={12} sm={12} md={12}>
                                    {UserRoleHelper.checkRole(roles.ROLE_PLATFORM_TARIFF_PUT) && (
                                        <CustomSmallTextButton label={'general:common.save'} callback={handleSubmit} callbackParam={{}} />
                                    )}
                                    <CustomSmallTextButton label={'general:common.cancel'} callback={returnFractionList} callbackParam={{}} />
                                </GridItem>
                            </GridContainer>
                        </CardBody>
                    </Card>
                </GridItem>
            </GridContainer>
        </React.Fragment>
    );
};

const mapStateToProps = (state: any): object => {
    return state;
};

const enhance = compose<any, any>(connect(mapStateToProps), withStyles(oplAppStyle));
const Enhance = enhance(FractionEdit);
export default Enhance;
